module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/107.78b130da.png";